import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/** one booking on a receipt: a charge that was paid for, or money that came in (negative when it went back) */
@Entity()
export class QuittungLine extends AdornisEntity {
  static override _class = 'QuittungLine';

  /** the accounting entry the line was read from — also what the client's entity store merges the lines by */
  @Field(() => ID)
  _id!: string;

  @Field(() => Date)
  date: Maybe<Date>;

  /** from the payer's side: a charge or a payment is positive, a credit note or a Rücklastschrift negative */
  @Field(() => Int)
  amountInMinorUnit: Maybe<number>;

  @Field(() => String)
  text: Maybe<string>;

  /** Lastschrift, Überweisung or Bar — empty on a charge */
  @Field(() => String)
  paymentKind: Maybe<string>;

  /** the payer's IBAN as the resolution found it; empty for most bookings */
  @Field(() => String)
  iban: Maybe<string>;
}
